export function rctiEmailPreview(text, values = {}, supplier = {}, currencyCode = "AUD") {
  const date = value => value && !Number.isNaN(new Date(value).getTime())
    ? new Date(value).toLocaleDateString("en-AU", {timeZone:"UTC"}) : "Not recorded";
  const replacements = {
    "[RCTINumber]": values.rctiNumber || "Assigned on issue",
    "[CustomerName]": supplier?.name || supplier?.companyName || values.supplierName || values.supplierCompanyName || "Supplier",
    "[RCTIAmount]": `${currencyCode} ${Number(values.finalAmount || 0).toLocaleString("en-AU",{minimumFractionDigits:2,maximumFractionDigits:2})}`,
    "[RCTIDate]": date(values.rctiDate),
    "[SupplyDate]": date(values.supplyDate),
    "[DueDate]": "Not applicable",
    "[RCTIStatus]": values.rctiStatus || "Unpaid",
  };
  return Object.entries(replacements).reduce((value,[key,replacement])=>value.split(key).join(String(replacement)),String(text || ""));
}
